import { getDeviceSchema, SIP } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import SipGatewaySelect from "Components/Shared/SipGatewaySelect";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Divider, Form, Header, Segment } from "semantic-ui-react";

const SipExtensionCreate = () => {
  const {
    save,
    nextExtension,
    validateExtension,
    validateName,
    uncreate,
    devices,
  } = useDevice();

  const initValues = {
    type: SIP,
    name: "",
    extension: nextExtension,
    sipExtension: {
      gateway: "",
      ringTime: 180,
      maxCallTime: 14400,
      present: "pass-through",
      countryCode: "gb",
      record: false,
      onComplete: "HANGUP",
      onNoAnswer: "HANGUP",
      onFail: "HANGUP",
      onBusy: "HANGUP",
    },
  };

  return (
    <Segment>
      <Header as='h3'>Create Sip Extension</Header>
      <Divider />
      <Formik
        initialValues={initValues}
        validationSchema={getDeviceSchema(SIP)}
        onSubmit={(values, actions) => {
          save(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />
            <Field
              name='extension'
              label='Extension'
              placeholder='100'
              min='100'
              max='9000'
              type='number'
              validate={validateExtension}
              component={CallableInput}
            />
            <SipGatewaySelect
              name='sipExtension.gateway'
              label='Gateway'
              devices={devices}
            />
            <FormSubmit
              name='Create Sip Extension'
              onCancel={uncreate}
              errors={props.errors}
            />
          </Form>
        )}
      </Formik>
    </Segment>
  );
};

export default SipExtensionCreate;
